import React, { Component } from 'react';

export default class CountDown extends Component {

    constructor (props) {
        super(props);

        this.state = {
            intervalId: false,
            countDown: 8
        }
    }

    componentWillMount () {
        this.startCountdown();
    }

    componentWillReceiveProps () {
        this.startCountdown();
    }

    componentWillUnmount () {
        clearInterval(this.state.intervalId);
    }

    render() {
        return (
            <span>{this.state.countDown}</span>
        );
    }

    startCountdown () {
        // Clear previous countdown
        clearInterval(this.state.intervalId);

        // Reset counter
        this.setState({countDown: 8});

        // Start new interval
        const intervalId = setInterval(this.countDown.bind(this), 1000);

        // Save interval
        this.setState({intervalId: intervalId});
    }

    countDown () {
        if (this.props.stopCountDown) return;

        if (this.state.countDown === 0) {
            this.props.countDownFinished();
        } else {
            this.setState({countDown: this.state.countDown - 1});
        }
    }

}


// WEBPACK FOOTER //
// ./src/components/DetailPage/CountDown/index.js